export type graphObject = {
  _id: string;
  outlet_name: string;
  revenue: number;
};

export const calculateGraph = (dashboardGraphArray: graphObject[]) => {
  let maxNumberOfDigits = 1;
  dashboardGraphArray.forEach((eachTerm: any) => {
    let numberOfDigits = numDigits(eachTerm.revenue);
    if (maxNumberOfDigits < numberOfDigits) maxNumberOfDigits = numberOfDigits;
  });
  return Math.pow(10, maxNumberOfDigits);
};

function numDigits(x: number) {
  return Math.max(Math.floor(Math.log10(Math.abs(x))), 0) + 1;
}

export const getTopValue = (word: string) => {
  return getNumberOfWords(word) + 1.3;
};
export const getNumberOfWords = (word: string) => {
  return word.split(" ").length;
};
